import { useState } from "react";
import { api } from "@/lib/marsheeApi";

export default function Login({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(email.trim(), password);
      const ok = await onSuccess();
      if (!ok) {
        setError("Signed in, but the session could not be established. Please try again.");
      }
    } catch (err) {
      setError(err.message || "Unable to sign in. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="login-page" style={{ backgroundColor: "#241D18", color: "#ECE5DB" }}>
      <div className="mx-auto w-full max-w-md px-6 sm:px-8" style={{ marginTop: "18vh" }}>
        <div className="mh-eyebrow" data-testid="login-brand" style={{ color: "#C6B39F" }}>Marshee HQ</div>
        <h1 className="mh-serif mt-4" style={{ fontSize: "clamp(1.9rem, 6vw, 2.6rem)", lineHeight: 1.1, letterSpacing: "-0.01em", color: "#ECE5DB", maxWidth: "16ch" }}>
          Welcome back.
        </h1>
        <p className="mh-sans mt-4" style={{ fontSize: "1rem", lineHeight: 1.6, color: "#8C7B6C", maxWidth: "38ch" }}>
          A private space. Sign in to return to the chapter you are living.
        </p>

        <form className="mt-10 space-y-6" onSubmit={submit} data-testid="login-form">
          <div>
            <label className="mh-label" htmlFor="login-email" style={{ color: "#C6B39F" }}>Email</label>
            <input
              id="login-email"
              type="email"
              className="mh-input mt-2"
              data-testid="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              style={{ background: "transparent", color: "#ECE5DB", borderColor: "#4A3D33" }}
            />
          </div>
          <div>
            <label className="mh-label" htmlFor="login-password" style={{ color: "#C6B39F" }}>Password</label>
            <input
              id="login-password"
              type="password"
              className="mh-input mt-2"
              data-testid="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              style={{ background: "transparent", color: "#ECE5DB", borderColor: "#4A3D33" }}
            />
          </div>

          {error && (
            <div data-testid="login-error" className="mh-fade" style={{ borderLeft: "2px solid #AD8F60", paddingLeft: "0.9rem", color: "#C9B7A6", fontSize: "0.95rem" }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="mh-btn mh-btn-primary"
            data-testid="login-submit"
            disabled={busy || !email.trim() || !password}
          >
            {busy ? "Signing in…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
